import * as React from "react";

const LinkIcon = (props) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M8 12h8m-1-4h2a4 4 0 0 1 0 8h-2M9 8H7a4 4 0 1 0 0 8h2"
			stroke="#5E666B"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default LinkIcon;
